import React, { useState, useRef, useEffect } from "react";
import { validateName, sanitizeName } from "../../../utils/profanityFilter";
import "./ProfileDialog.css";

interface ProfileDialogProps {
  currentName: string;
  onSave: (newName: string) => void;
  onClose: () => void;
}

export const ProfileDialog: React.FC<ProfileDialogProps> = ({
  currentName,
  onSave,
  onClose,
}) => {
  const [name, setName] = useState(currentName);
  const [error, setError] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedName = name.trim();

    const validation = validateName(trimmedName);
    if (!validation.isValid) {
      setError(validation.reason || "Ungültiger Name");
      return;
    }

    setError(null);
    onSave(sanitizeName(trimmedName));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = sanitizeName(e.target.value);
    setName(sanitized);
    if (error) setError(null);
  };

  const handleOverlayClick = () => {
    onClose();
  };

  return (
    <div className="profile-dialog">
      <div className="profile-dialog__overlay" onClick={handleOverlayClick} />
      <div className="profile-dialog__modal">
        <button
          className="profile-dialog__close"
          onClick={onClose}
          type="button"
        >
          ×
        </button>
        <div className="profile-dialog__avatar">👤</div>
        <h2 className="profile-dialog__title">Profil bearbeiten</h2>
        <form onSubmit={handleSubmit} className="profile-dialog__form">
          <label className="profile-dialog__label">Anzeigename</label>
          <input
            ref={inputRef}
            type="text"
            value={name}
            onChange={handleInputChange}
            className={`profile-dialog__input ${error ? "profile-dialog__input--error" : ""}`}
            placeholder="Gib deinen Namen ein"
            maxLength={20}
          />
          {error && <div className="profile-dialog__error">{error}</div>}
          <div className="profile-dialog__actions">
            <button
              type="button"
              className="profile-dialog__btn profile-dialog__btn--secondary"
              onClick={onClose}
            >
              Abbrechen
            </button>
            <button
              type="submit"
              className="profile-dialog__btn profile-dialog__btn--primary"
              disabled={!name.trim()}
            >
              Speichern
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
